export enum CustomerInsightResult {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  // legacy ones, these should be removed once we remove the uinified-agent-enabled flag
  LOW_RISK = 'LOW_RISK',
  HIGH_RISK = 'HIGH_RISK',
  INCONCLUSIVE = 'INCONCLUSIVE',
}

export interface CustomerInsightCategory {
  label: string;
  order: number;
}

export const CUSTOMER_INSIGHT_CATEGORIES: Record<
  string,
  CustomerInsightCategory
> = {
  DOCUMENT_RISK: {
    label: 'Document Risk',
    order: 1,
  },
  IDENTITY_VERIFICATION: {
    label: 'Identity Verification',
    order: 2,
  },
  BUSINESS_LEGITIMACY: {
    label: 'Business Legitimacy',
    order: 3,
  },
  BUSINESS_OWNER_LEGITIMACY: {
    label: 'Business Owner Legitimacy',
    order: 4,
  },
  RISK_ASSESSMENT: {
    label: 'Risk Assessment',
    order: 5,
  },
  FINANCIAL_LEGITIMACY: {
    label: 'Financial Legitimacy',
    order: 6,
  },
  TRANSACTION_PATTERNS: {
    label: 'Transaction Patterns',
    order: 7,
  },
  CUSTOM: {
    label: 'Custom',
    order: 8,
  },
};

export interface CustomerInsightTransaction {
  id: string;
  date: string;
  description: string;
  amount: number;
  currency_code: string;
  category: string;
  method: string;
  merchant: string;
}

export interface CustomerInsightDailyBalance {
  balance: number;
  period_start: string;
  period_end: string;
  bank_account_uuid: string;
  bank_account_last_four: string;
}
